/* eslint-disable camelcase */
/**
 * @author Fernando Ruano
 * @file saga.js
 * @description Country User Role Saga
 */

// Dependencies
import { put, call, takeLatest } from 'redux-saga/effects';

// Services
import countryUserRoleService from '@nephro/services/countryUserRole-service';

// Global actions
import { setResponse, setLoading } from '@nephro/redux/stores/app/actions';

// Constants
import {
  CREATE_COUNTRY_USER_ROLE,
  DELETE_COUNTRY_USER_ROLE_BY_ID,
  GET_ALL_COUNTRY_USER_ROLES,
  GET_COUNTRY_USER_ROLE_BY_ID,
  UPDATE_COUNTRY_USER_ROLE
} from './constants';

const customError = {
  type: 'Error',
  message: 'commons.problem'
};

/**
 * Call service to get countryUserRoles from backend
 * @param { object } action - Action with payload data
 */
export function* getCountryUserRolesArray(action) {
  yield put(setLoading(true));
  yield put(setResponse(false, false, false));
  const {
    callback,
    payload: { data }
  } = action;
  const { paged, page, limit } = data;

  try {
    const response = yield call(
      countryUserRoleService.getCountryUserRoles,
      paged,
      limit,
      page
    );
    yield put(setResponse('success', false, false, { ...response }, callback));
  } catch (err) {
    yield put(
      setResponse(
        'error',
        false,
        err.message || customError.message,
        false,
        callback
      )
    );
  } finally {
    yield put(setLoading(false));
  }
}

/**
 * Call service to get countryUserRole info by id
 * @param { object } action - Action with payload data
 */
export function* getCountryUserRoleById(action) {
  yield put(setLoading(true));
  yield put(setResponse(false, false, false));
  const {
    callback,
    payload: { data }
  } = action;
  const { id } = data;

  try {
    const response = yield call(
      countryUserRoleService.getCountryUserRoleById,
      id
    );
    yield put(setResponse('success', false, false, { ...response }, callback));
  } catch (err) {
    yield put(
      setResponse(
        'error',
        'Error',
        'errors.countryUserRoleNotFound' || customError.message,
        false,
        callback
      )
    );
    yield put(setResponse(false, false, false));
    yield put(setLoading(false));
  }
}

/**
 * Call service to create countryUserRole
 * @param { object } action - Action with payload data
 */
export function* createCountryUserRole(action) {
  yield put(setLoading(true));
  yield put(setResponse(false, false, false));
  const {
    callback,
    payload: { data }
  } = action;
  const { country, profile, role, user, id_clinic } = data;

  try {
    const response = yield call(
      countryUserRoleService.createCountryUserRole,
      country,
      profile,
      role,
      user,
      id_clinic
    );
    yield put(
      setResponse(
        'success',
        'new country user rol',
        'curMg.itemCreated',
        response,
        callback
      )
    );
    yield put(setResponse(false, false, false));
  } catch (err) {
    yield put(
      setResponse(
        'error',
        false,
        err.message || customError.message,
        false,
        callback
      )
    );
    yield put(setResponse(false, false, false));
    yield put(setLoading(false));
  }
  yield put(setLoading(false));
}

/**
 * Call service to update countryUserRole
 * @param { object } action - Action with payload data
 */
export function* updateCountryUserRole(action) {
  yield put(setLoading(true));
  yield put(setResponse(false, false, false));
  const {
    callback,
    payload: { data }
  } = action;
  const { country, profile, role, user, id_clinic, id } = data;
  try {
    const response = yield call(
      countryUserRoleService.updateCountryUserRole,
      country,
      profile,
      role,
      user,
      id_clinic,
      id
    );
    yield put(
      setResponse(
        'success',
        'updated country user rol',
        'curMg.itemUpdated',
        response,
        callback
      )
    );
    yield put(setResponse(false, false, false));
  } catch (err) {
    yield put(
      setResponse(
        'error',
        false,
        err.message || customError.message,
        false,
        callback
      )
    );
    yield put(setResponse(false, false, false));
    yield put(setLoading(false));
  }
  yield put(setLoading(false));
}

/**
 * Call service to delete countryUserRole info by id
 * @param { object } action - Action with payload data
 */
export function* deleteCountryUserRoleById(action) {
  yield put(setLoading(true));
  yield put(setResponse(false, false, false));
  const {
    callback,
    payload: { data }
  } = action;
  const { id } = data;

  try {
    const response = yield call(
      countryUserRoleService.deleteCountryUserRoleById,
      id
    );
    yield put(
      setResponse(
        'success',
        'deleted rol',
        'curMg.itemDeleted',
        { ...response },
        callback
      )
    );
    yield put(setResponse(false, false, false));
  } catch (err) {
    yield put(
      setResponse(
        'error',
        'Error',
        err.message || customError.message,
        false,
        callback
      )
    );
    yield put(setResponse(false, false, false));
    yield put(setLoading(false));
  }
  // yield put(setLoading(false));
}

/**
 * Declare all component sagas
 */
export function* watchCountryUserRoleSaga() {
  yield takeLatest(GET_ALL_COUNTRY_USER_ROLES, getCountryUserRolesArray);
  yield takeLatest(GET_COUNTRY_USER_ROLE_BY_ID, getCountryUserRoleById);
  yield takeLatest(CREATE_COUNTRY_USER_ROLE, createCountryUserRole);
  yield takeLatest(UPDATE_COUNTRY_USER_ROLE, updateCountryUserRole);
  yield takeLatest(DELETE_COUNTRY_USER_ROLE_BY_ID, deleteCountryUserRoleById);
}
